import { createFileRoute } from "@tanstack/react-router";
import { protectedRoute } from "@/lib/protectedRoute";
import { Settings } from "@/pages/Settings";

export const Route = createFileRoute("/settings")({
  component: Settings,
  beforeLoad: () => {
    return protectedRoute({ location: window.location });
  },
});
